import { CloudDone, SwipeUpAlt } from "@mui/icons-material";
import { Box, CardHeader, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { ReactElement } from "react";

const PrimaryCardHeader = styled(CardHeader)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    color: "white",
}));

const WarningCardHeader = styled(CardHeader)(({ theme }) => ({
    backgroundColor: theme.palette.warning.main,
    borderRadius: theme.shape.borderRadius,
    color: "white",
}));

export interface IFormSectionHeader {
    label: string,
    color?: "primary" | "warning" | undefined,
    saving?: boolean | undefined
}

export const FormSectionHeader: React.FC<IFormSectionHeader> = ({
    label,
    color,
    saving

}: IFormSectionHeader) => {

    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 });


    const Subheader: React.FC = () => {

        return (
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>


                <Typography color="secondary">{label}</Typography>
                <Box>
                    {
                        saving !== undefined && (saving === true ?
                            <Box display="inline-block" position="absolute" sx={{ marginLeft: "-1.4em", paddingTop: "4px", opacity: .2 }}>
                                <Tooltip title="saving changes in progress">
                                    <CircularProgress color="secondary" size="1em" />
                                </Tooltip>
                            </Box>
                            :
                            <Tooltip title="saved">
                                <CloudDone
                                    color="secondary"
                                    sx={{
                                        position: "absolute",
                                        marginLeft: "-1em",
                                        paddingTop: "4px",
                                        opacity: .2
                                    }} />
                            </Tooltip>
                        )
                    }
                    <Tooltip title="back to top">
                        <IconButton
                            size="small"
                            color="secondary"
                            sx={{ p: 0, opacity: .2 }}
                            onClick={scrollToTop}
                        ><SwipeUpAlt /></IconButton>
                    </Tooltip>
                </Box>

            </Box>
        )
    };

    return color === "warning" ? <WarningCardHeader sx={{ m: 1 }} subheader={<Subheader />} /> : <PrimaryCardHeader sx={{ m: 1 }} subheader={<Subheader />} />;
}